<template>
  <div class="container">
    <link rel="stylesheet" href="/css/bulmaswatch.min.css">
    <!-- XXX extend Navigation -->
    <div id="navigoo">
      <a href="/">&larr; Home</a>
      <a @click="helpShortcuts">Info</a>
      <a @click="toggleLayers">Layers [<span class="layer-sel">all</span>]</a>
      <a @click="toggleEffects">FX</a>
      <a @click="toggleText">TXT</a>
      <a @click="go">GO!</a>
    </div>


    <div class="columns">

      <div id="container" class="column is-12">
        <canvas id="stage" width="600" height="400"></canvas>
      </div>
    </div>
    <div class="columns">

      <div v-if="loaded" class="column is-4" id="layers">

           <h4 class="title is-4">
            Layers

            <b-field id="uploadFile" class="is-pulled-right">
              <b-tooltip label="Drop or click to upload image"
                          type="is-dark"
                          position="is-bottom">
                <b-upload v-model="dropFiles" multiple drag-drop>
                     <div class="content has-text-centered">
                       <b-icon icon="upload" size="is-medium"></b-icon>
                     </div>
                </b-upload>
              </b-tooltip>
           </b-field>

           <div class="is-clearfix"></div>
          </h4>

          <div class="columns layer" v-for="(layer, index) in layers.slice().reverse()" v-bind:key="layer.name" v-bind:class="{'is-layer-hidden': !layer.visible}">
            <div class="column is-7 layer-name" v-bind:class="{ selectedLayer: layer.isSelected }" @click="selectLayer(layers.length-index)">
              <!--{{index+1}}. -->[{{layer.zIndex.toString().padStart(2, '0')}}] {{layer.name}}
            </div>
            <div class="column is-5 layer-controls">
              <b-button class="is-small"
                  type="button" icon-left="blur-off"
                  @click="toggleLayer(layer.name)">
              </b-button>

              <b-button class="is-small"
                  type="button" icon-left="close"
                  @click="deleteLayer(layer.name)">
              </b-button>

              <b-button class="is-small" type="button" icon-left="arrow-down" @click="orderLayer(layer.name, -1)">
              </b-button>

              <b-button class="is-small" type="button" icon-left="arrow-up" @click="orderLayer(layer.name, +1)">
              </b-button>
            </div>
          </div>

        <!--b-field label="Text">
          <b-input v-model="text" maxlength="200" type="textarea"></b-input>
        </b-field-->

      </div>


      <div v-if="loaded" class="column is-4" id="effects">
          <h4 class="title is-4">Effects [<span class="layer-sel">*</span>]</h4>
          <ul>
            <li>blendMode</li>
            <li>ASCII,CRT; etc.</li>
          </ul>

          <b-select type="is-small" v-model="selectedBlendMode" v-on:input="blendMode">
            <option v-for="b of blendModes" :value="b" :key="b">{{b}}</option>
          </b-select>
      </div>

      <div v-if="loaded" class="column is-4" id="texts">
          <h4 class="title is-4">Texts</h4>

          <b-select type="is-small" v-model="fontFamily">
            <option v-for="f of fontFamilies" :value="f" :key="f">{{f}}</option>
          </b-select>
          <b-input v-model="fontSize" maxlength="20" type="number"></b-input>
          <b-input v-model="fillColor" type="color"></b-input>
          <b-input v-model="text" maxlength="200" type="textarea"></b-input>
		  <b-button class="is-medium" type="button" @click="addText()">
		  Add Text
		  </b-button>
      </div>

    </div>

  </div>
</template>

<script>

import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Navigation from '@/components/Navigation'
import SimplexNoise from 'simplex-noise'
import Editor from '@/doodles/editor'
import keyboardShortcuts from '@/utils/keyboardShortcuts'
import * as PIXI from 'pixi.js'
import * as filters from 'pixi-filters'
import axios from 'axios'

export default {
  name: 'Doodle',
  components: {
    Navigation
  },
  data() {
    return {
      loaded: false,
      text: '100%ACID--"OKOK"',
	    fontSize: parseInt(10 + Math.random()*20),
      fontFamilies: ['Special Elite', 'blockzone', 'Avenir', 'Helvetica', 'Arial'],
      fontFamily: 'Special Elite',
      fillColor: '#ffffff',
      dropFiles: [],
      selectedBlendMode: "NORMAL",
      blendModes: [
        "NORMAL", "ADD", "MULTIPLY", "SCREEN", "OVERLAY", "DARKEN", "LIGHTEN", "COLOR_DODGE", "COLOR_BURN", "HARD_LIGHT", "SOFT_LIGHT", "DIFFERENCE", "EXCLUSION", "HUE", "SATURATION", "COLOR", "LUMINOSITY", "NORMAL_NPM", "ADD_NPM", "SCREEN_NPM", "NONE", "SRC_IN", "SRC_OUT", "SRC_ATOP", "DST_OVER", "DST_IN", "DST_OUT", "DST_ATOP", "SUBTRACT", "SRC_OVER",
      ],
      layers: []
    }
  },
  watch: {
    dropFiles(o, n) {
      if (!o[0]) {
        return
      }

      let reader = new FileReader()

      reader.addEventListener('load', () => {
        let sprite = this.demo.addURLAsLayer(reader.result)
      }, false)

      reader.readAsDataURL(o[0])
    }
  },
  methods: {
    deleteDropFile(index) {
        this.dropFiles.splice(index, 1)
    },
    toggleLayers() {
      document.querySelector('#layers').style.display =
        (document.querySelector('#layers').style.display == 'block')
        ? 'none' : 'block'
    },
    toggleEffects() {
      document.querySelector('#effects').style.display =
        (document.querySelector('#effects').style.display == 'block')
        ? 'none' : 'block'
    },
    toggleText() {
      document.querySelector('#texts').style.display =
        (document.querySelector('#texts').style.display == 'block')
        ? 'none' : 'block'
    },
    // XXX move to keyboardShortcuts
    helpShortcuts(e) {
      e.preventDefault()
      let keys = {
        'l': 'toggle layers view',
        //'d/D': 'delete layer',

        'r/R': 'reload',
        '&#x232b;': 'undo',
        'e/E': 'export image',
        'h/H': 'this infobox',
        '0..9': 'select layer (used for filters & effects)',
        'z': 'deselect layer',
        // filters
        'g': 'glitch filter',
        'a': 'ascii filter',
        'c': 'CRT filter',
        'x': 'horizontal layer flip',
        'y': 'vertical layer flip',
        // '-': 'move layer down',
        // '+': 'move layer up',
      }
      let keyslist = Object.keys(keys).map(k =>
        `<li><dl><dt>${k}</dt><dd>${keys[k]}</dd></dl></li>`).join('')

      let message = `<ul>${keyslist}</ul>`

      this.$buefy.dialog.alert({
          title: 'Shortcuts',
          message,
          confirmText: 'Cool!'
      })
    },
    // fucked up binding, doesnt work
    getLayers() {
      this.layers = this.demo.layers
    },
    deleteLayer(name) {
      this.demo.deleteLayer(name)
      this.getLayers()
    },
    orderLayer(name, order) {
      this.demo.orderLayer(name, order)
      this.getLayers()
    },
    toggleLayer(name) {
      this.demo.toggleLayer(name)
      this.getLayers()
    },
    selectLayer(index) {
      this.demo.setCurrentLayer(index)
    },
    blendMode(event) {
      let l = this.demo.getActiveLayer()

      this.demo.logAction('blendMode', {blendMode: l.blendMode})

      l.blendMode = PIXI.BLEND_MODES[this.selectedBlendMode]
    },
	addText() {
      this.demo.text(this.text, {
        x: Math.random()*400,
        y: Math.random()*400,
        fontSize: parseInt(this.fontSize),
        fontFamily: this.fontFamily,
        fillColor: this.fillColor
      })

      // select the added layer
      this.demo.setCurrentLayer()
	},
    go() {

    }
  },
  created() {
    window.onload = () => {
      this.demo = new Editor()

      keyboardShortcuts(this.demo)

      // load default resources
      //this.demo.addURLAsLayer('/img/archive/c2h_m0GrrI.jpeg')
      //this.demo.addURLAsLayer('/img/archive/1317310244-1.jpg')
      //this.demo.addURLAsLayer('/img/dump/c2h_1393342887.jpg')


      /*
      // wellcome
      axios.get('https://api.wellcomecollection.org/catalogue/v2/works/f4uy5dw7')
      .then((res) => {
        console.log(res)
      })
      */

      let self = this
      function gotImages(images) {
        // add three of them as a layer
        for (let i = 0; i < 3; i++) {
          self.demo.addURLAsLayer(images[Math.floor(Math.random() * images.length)])
        }

        txtf00()

        self.getLayers()
        self.loaded = true
      }

    // c2h image archive as src
    axios.get('/data/images.json')
      .then((res) => {
        let images = res.data.map(item => `/img/archive/${item.filename}`)
        return gotImages(images)
      })

    const txtf00 = () => {
      let tt = "ShuStevens-Johnson syndromeShin splintsBasilisHepatitis DAyahuascaNightshadeCholera5-MeO-DIPTAloesEithinoha MolpadiaMonogenesCocainePramiracetamTMA-2StrifeH.B. Woodrose4-MethylaminorexAlprazolamPiperazinesAlzheimer's diseaseKriophorosNakawStomach fluHuang T'ingErectile dysfunctionCommon coldDiplopterysAmala SclerodermaChlordiazepoxidePituriGangreneKavaBelit-SeriDOMHenbaneLeishmaniasisHorusRheumatismSalmonellosisMOO-LAUHarmalaLymphogranuloma venereumHydrocodoneSamundraTetanusBres2C-BPuthiosHekatosTemazepamAmblyopiaMeperidineWhope 4-HO-MIPTSynovitisPalindromic rheumatismGynnisBotulismPsilocybin & PsilocinGrowth HormonePeritonitisEpikourios PCPUrienRepetitive strain injuryHuman papillomavirusNagi Tanka MulukuPeriwinkleSisiutl centaurTomitukaLicoriceVaricellaQuetiapineCherubismMultiple sclerosisAniracetamMeperidineAlcoholLeishmaniasisEshmunAneurduNightshadeTrigonosAchondroplasiaZuShuHashishUgly Way Chou WangMononucleosisAnpaoBaurosH.B. WoodroseThalestrisCocaineAsthmaAjokChloris ClonidineArgyriaSIDSSan PedroRusalkiEar infectionCannabisKetamineCannabinoidsThymomaSpice ProductTyphoid feverApraxiaAlingaNight blindnessCoronary heart diseaseAnadenantheraNutmegBrucellosisRubellaTennis elbowComfreyGHBPsilocybin & PsilocinObumoMictecacihuatl"

      function shuffle(a) {
        for (let i = a.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [a[i], a[j]] = [a[j], a[i]];
        }
        return a;
      }

      tt = shuffle(tt.split(' ')).join(' ').replace(/\s+/g, '')

      let t = ''
      for  (let i = 0; i < tt.length; i++) {
        t += tt[i]
        if (Math.random() < .2) {
          t += tt[i].toUpperCase().repeat(Math.random() * 5)
        }

        if (Math.random() < .1) {
          t += " ".repeat(Math.random() * 5)
        }

        if (Math.random() < .05) {
          t += "\n".repeat(Math.random() * 5)
        }
      }

      //return
      // add 3 layers of text

      for (let i = 0; i < 3; i++) {
        let start = Math.random() * t.length-32,
            num = Math.random() * 64

        t = t.slice(start, start+num)

        let txtLayer = this.demo.text(t, {
          x: Math.random()*400,
          y: Math.random()*400,
          fontSize: 10 + Math.random()*20,
          fontFamily: 'Special Elite'
        })

        txtLayer.filters = [
          new filters.GlowFilter(2, 2, 0, 0x6a93ff, .1),
        ]
      }

      this.demo.filter(new filters.CRTFilter({
        curvature: 0, lineWidth: 2, lineContrast: .3,
        noise: .08, noiseSize: 1.9, vignetting: 0, time: .5
      }))

    } // /txtf00

    }
  }
}

</script>

<style>
#app {
  margin-top: 40px;
}
#canvas {
  border: 1px solid #121212;
}
b-field#uploadFile {
  margin: 0 auto;
}
.upload .upload-draggable {
  padding: 1.0em;
}
dl dt, dl dd {
  display: inline-block;
}
dl dt {
  padding-right: 20px;
  clear: both;
}
.is-layer-hidden .layer-name {
  text-decoration: line-through;
}
.layer-controls {
  cursor: pointer;
}
#layers,
#effects,
#texts {
  background: #660000;
  opacity:0.95;
  position: absolute;
  left: 0px;
  top: 0px;
  margin-left: -50px;
  display: none;
}
.layer .selectedLayer {
  font-style: italic;
  color: #999;
}

#effects {
  background: #990000;
}
</style>
